// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__7MV_N","options":"AnswerScale_options__1sHFo","selected":"AnswerScale_selected__1VY5-"};